// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dqKb2{margin:0}.QAznx{padding:6px 8px 7px 8px;text-align:left}", "",{"version":3,"sources":["webpack://./src/desktop/components/RiddlesAdmin/SelectLang/selectlang.scss"],"names":[],"mappings":"AAAA,OACE,QAAA,CAGF,OACE,uBAAA,CACA,eAAA","sourcesContent":[".wrapper {\n  margin: 0;\n}\n\n.selected {\n  padding: 6px 8px 7px 8px;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "dqKb2",
	"selected": "QAznx"
};
export default ___CSS_LOADER_EXPORT___;
